/**
 * Converts a hex color (#fff, #ffffff) into an "r, g, b" string.
 */
function hexToRgb(color) {
  if (typeof color !== "string") return color;

  let hex = color.replace("#", "");

  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((c) => c + c)
      .join("");
  }

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return `${r}, ${g}, ${b}`;
}

export default hexToRgb;
